import { useFormValidation } from 'common/hooks/useFormValidation';
import PropTypes from 'prop-types'
import React, { useEffect, useRef } from 'react';
import { useState } from 'react';


const RolesSelection = ({ availableRoles, selectedRoles, onChange }) => {

  const [_selectedRoles, setSelectedRoles] = useState(selectedRoles);

  const handleChange = (e) => {
    if (e.target.checked) {
      setSelectedRoles((roles) => [...roles, e.target.value]);
    } else {
      setSelectedRoles((roles) => roles.filter(r => r !== e.target.value));
    }
  };

  useEffect(() => {
    onChange(_selectedRoles);
  }, [_selectedRoles]);

  return (
    <React.Fragment>

      {availableRoles.map(role => (
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            name={`role_${role}`}
            value={role.key}
            onChange={handleChange}
            checked={_selectedRoles.includes(role.key)}
          />
          <label className="form-check-label align-middle" htmlFor={`role_${role}`}>
            {role.value}
          </label>
        </div>
      ))}
    </React.Fragment>
  )
}

const UserEditForm = ({ model, availableRoles = [], onChange, onSubmit, t, children }) => {

  const isNew = !model.uuid;
  const [passwordEditMode, setPasswordEditMode] = useState(isNew);
  const [validationErrors, validate] = useFormValidation({}, t);

  const formRef = useRef();

  const handleChange = (e, propName, propValue) => {
    const { name, value } = propName ? { name: propName, value: propValue } : e.target;

    onChange(name, value);
  };

  const handleSubmit = (e) => {

    e.preventDefault();

    if ( !validate(e.target) ) {
      return;
    }

    onSubmit();
  };

  return (
    <form noValidate ref={formRef} onSubmit={handleSubmit} className="yoso-form">
      <div className="mb-3">
        <label htmlFor="name" className="form-label">{t('user.name')}</label>
        <input type="text" name="name" className="form-control" value={model.name} onChange={handleChange} required maxLength={100} autoFocus />
        <div className="text-danger">
          {validationErrors.name}
        </div>
      </div>

      <div className="mb-3">
        <label htmlFor="username" className="form-label">{t('user.username')}</label>
        <input type="text" name="username" className="form-control" value={model.username} onChange={handleChange} required disabled={!isNew} minLength={4} maxLength={100} />
        <div className="text-danger">
          {validationErrors.username}
        </div>
      </div>


      { !isNew ? <div className="mb-3 form-switch form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id="continuous"
          onChange={() => setPasswordEditMode(mode => !mode)}
          checked={passwordEditMode}
        />
        <label className="form-check-label align-middle" htmlFor="continuous">
          {t('form.labels.editPassword')}
        </label>
      </div> : null}

      <div className="mb-3">
        <label htmlFor="password" className="form-label">{t('user.password')}</label>
        <input type="password" name="password" className="form-control" value={model.password} autoComplete="new-password" onChange={handleChange} disabled={!passwordEditMode} required minLength={6} />
        <div className="text-danger">
          {validationErrors.password}
        </div>
      </div>

      <div className="mb-3">
        <label htmlFor="email" className="form-label">{t('user.email')}</label>
        <input type="email" name="email" className="form-control" value={model.email} onChange={handleChange} required />
        <div className="text-danger">
          {validationErrors.email}
        </div>
      </div>


      <label>{t('user.roles')}</label>
      <input type="number" name="selectedRoleCount" style={{ display: 'none' }} value={model.roles.length > 0 ? model.roles.length : ''} required/>
      <RolesSelection
        availableRoles={availableRoles}
        selectedRoles={model.roles}
        onChange={(roles) => handleChange(null, 'roles', roles)}
      />
      <div className="text-danger">
        {validationErrors.selectedRoleCount}
      </div>

      <div className="row mb-3 mt-3">
        <div className="col-sm-6 col-xs-12 text-end">
          <button type="submit" className="btn btn-primary">{t('common:actions.save')}</button>
        </div>
        {children}
      </div>
    </form>
  )
}

UserEditForm.propTypes = {
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    username: PropTypes.string,
    email: PropTypes.string,
    roles: PropTypes.arrayOf(PropTypes.string),
  })
};



export default UserEditForm;
